export default __webpack_public_path__ + "static/media/boc.dc011e0a.svg";